import React, { useState, useEffect } from 'react';
import { SelectableButtonsItem } from './SelectableButtonsItem';

export const SelectableButtons = props => {
  const [listFeature, setListFeature] = useState([]);

  useEffect(() => {
    console.warn(props.setFeature);
  }, []);

  const handleSelectClick = e => {};
  const handleSelectItemClick = e => {
    console.warn(handleSelectItemClick, e);

    props.setFlow(e);
  };

  return (
    <div
      style={{
        overflowX: 'hidden',
        overflowY: 'auto',
        height: '200px',
        width: '400px',
        paddingLeft: '10%',
      }}
    >
      {props.selectItem.map(element => (
        <SelectableButtonsItem key={element.text} item={element} onClick={handleSelectItemClick}></SelectableButtonsItem>
      ))}
    </div>

    // <Button {...this.props}   />
  );
};
